import { Vector3, Matrix4, Quaternion } from 'three';

const _rotation = new Quaternion();
const _dummyVec = new Vector3();

export const applyOnlyRotation = (target: Vector3, matrix: Matrix4): Vector3 => {
    matrix.decompose(_dummyVec, _rotation, _dummyVec); // ignore position and scale
    return target.applyQuaternion(_rotation);
};
